// Shared label/formatting helpers for roof-related UI.
// NOTE: Logic copied from QuoteSummary.jsx and PrintableQuote.jsx. Behavior MUST remain identical.

export function getMaterialLabel(material) {
  const labels = {
    asphalt: 'Asphalt Shingles',
    cedar: 'Cedar / Wood Shakes',
    stone: 'Stone / Concrete / Slate',
  };
  return labels[material] || material;
}

export function getStageLabel(stage) {
  const labels = {
    stage1: 'Stage 1 – Black Streaks/Green',
    stage2: 'Stage 2 – Lichen',
    stage3: 'Stage 3 – Moss',
  };
  return labels[stage] || stage;
}

export function getStoriesLabel(stories) {
  const labels = {
    '1': 'One Story',
    '2': 'Two Story',
    '3': 'Three or More Stories',
  };
  return labels[stories] || stories;
}
